import styled from 'styled-components';

export default styled.td`
  white-space: nowrap;
  color: #c5cede;
`;
